<template>

    <li class="p-2 text-sm text-theme-main flex flex-row items-center hover:bg-theme-level4 cursor-pointer hover-vis-trigger rounded-md" @click.stop="playThisItem">

        <img v-if="playlistItem.legacy" :src="legacy_thumbnail" @error="$event.target.src=default_thumbnail" alt="thumbnail" style="width: 80px; height: 45px;" class="mr-4">
        <img v-else :src="thumbnail" alt="thumbnail" style="width: 80px; height: 45px;" class="mr-4">

        <p class="flex flex-col w-4/5">
            <span class="font-bold mb-2">{{ playlistItem.title }}</span>
            <span>{{ playlistItem.publish_date }}</span>
        </p>
        <span class="hover-vis-target relative ml-8 mr-2 w-8 h-8 hover:bg-theme-level2 cursor-pointer rounded-lg hover-vis-trigger text-red-200 hover:text-red-500" @click.stop="removeFromPlaylist">
            <i class="material-icons w-8 h-8 pl-1 pt-1">delete_forever</i>
            <span class="absolute px-3 py-1 mb-1 bg-theme-copy3 rounded-lg text-xs text-white text-center
                    hover-vis-target flex-1 w-48
                    transform transition-all duration-200"
                  style="bottom: 100%; left: 50%; transform: translate(-70%, 0);">
                {{ translate('playlist-remove-item') }}
                <svg class="absolute text-theme-copy3 w-full h-2"
                     style="top: 100%; left: 21%;"
                     x="0px" y="0px" viewBox="0 0 255 255" xml:space="preserve">
                    <polygon class="fill-current" points="0,0 127.5,127.5 255,0"></polygon>
                </svg>
            </span>
        </span>

    </li>

</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        data() {

            return {

                playlistItem: this.item

            }

        },

        props: [

            'currentlocale',
            'item',
            'thumbnail',
            'legacy_thumbnail',
            'default_thumbnail',
            'item_playlist'

        ],

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            playThisItem() {
                console.log('Playing ' + this.item.id)
                Event.fire('updateVideoPlayer', this.item)
            },

            removeFromPlaylist() {

                axios.get('/' + this.currentlocale + '/playlists/remove/' + this.item_playlist + '/' + this.item.id)
                    .then((response) => {
                        this.$parent.getPlaylistContent(this.item_playlist)
                        this.flashMessage.success({
                            title: '',
                            message: this.translate('playlist-item-removed'),
                            blockClass: 'p-6',
                            x: 25,
                            y: 20,
                            time: 3000
                        });
                    })
                    .catch((error) => {
                        console.log('ERROR trying to remove Content ID: ' + this.item.id + ' from Playlist ID: ' + this.item_playlist + ': ' + error)
                    })

            }

        }

    }

</script>
